export const canUsePaymentFields = appContext => {
    const stripe = appContext?.payments?.stripe;
    return !!stripe?.stripeAccountId && stripe?.chargesEnabled === true;
}

export const CROSS_WORKSPACE_PAYMENT_MESSAGE =
    "Payment fields cannot be used when a form sends enquiries to another workspace.";

export const hasCrossWorkspaceEnquiryRoute = (formSpec = {}, currentWorkspaceId) => {
    const sourceWorkspaceId = Number(currentWorkspaceId);
    if (!Number.isFinite(sourceWorkspaceId)) return false;

    const rules = formSpec?.rules || {};
    const routes = [rules, ...(Array.isArray(rules.submissionRules) ? rules.submissionRules : [])];

    return routes.some(route => {
        const configuredWorkspaceId = route?.enquiryTypeWorkspaceId;
        if (configuredWorkspaceId === null || configuredWorkspaceId === undefined || configuredWorkspaceId === '') {
            return false;
        }
        const targetWorkspaceId = Number(configuredWorkspaceId);
        return Number.isFinite(targetWorkspaceId) && targetWorkspaceId !== sourceWorkspaceId;
    });
}

export const hasOtherPaymentField = (fieldsets = [], currentControlId) => {
    const hasPayment = fields => (fields || []).some(field => {
        const isCurrentControl = !!currentControlId &&
            (field?.id === currentControlId || field?.name === currentControlId);
        if (field?.type === "payment" && !isCurrentControl) return true;
        return hasPayment(field?.fields);
    });

    return (fieldsets || []).some(fieldset => hasPayment(fieldset?.fields));
}

const PAYMENT_FIELD_TEMPLATES = [
    {
        label: "Save Card",
        defaultLabel: "Card Details",
        value: "payment-card-capture",
        mode: "card-capture"
    },
    {
        label: "Place Card Hold",
        defaultLabel: "Card Hold",
        value: "payment-security-hold",
        mode: "security-hold"
    },
    {
        label: "Take Payment",
        defaultLabel: "Payment",
        value: "payment-take-payment",
        mode: "take-payment"
    }
];

export const getPaymentFieldOptions = (appContext, paymentFieldExists = false, unavailableReason = null) => {
    const available = canUsePaymentFields(appContext);
    const unavailableAcrossWorkspaces = !!unavailableReason;
    const groupLabel = unavailableAcrossWorkspaces
        ? "Payment (not available across workspaces)"
        : !available
            ? "Payment (connect Stripe first)"
            : paymentFieldExists
                ? "Payment (already added)"
                : "Payment";

    return PAYMENT_FIELD_TEMPLATES.map(template => ({
        label: template.label,
        defaultLabel: template.defaultLabel,
        value: template.value,
        controlType: "payment",
        fieldDefaults: {
            mode: template.mode,
            // Keep the account behaviour explicit as soon as a payment template is selected. Without these values,
            // the controls render their visual defaults but dependent settings (such as Allow Account Creation)
            // remain hidden until the field has been saved and reopened.
            customerAccountMode: "required",
            allowInlineRegistration: true,
            ...(template.mode === "card-capture" ? {} : {
                currency: appContext?.currency || "AUD"
            }),
            ...(template.mode === "security-hold" ? {
                holdDurationHours: 72
            } : {})
        },
        group: {label: groupLabel},
        disabled: unavailableAcrossWorkspaces || !available || paymentFieldExists,
        disabledReason: unavailableReason || null
    }));
}

export const getPaymentFieldSelectionValue = mode => (
    PAYMENT_FIELD_TEMPLATES.find(template => template.mode === mode)?.value ||
    PAYMENT_FIELD_TEMPLATES[0].value
);
